import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {Auth, authState} from '@angular/fire/auth';
import {MatToolbar} from '@angular/material/toolbar';
import {MatButton} from '@angular/material/button';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatIcon} from '@angular/material/icon';
import {NgOptimizedImage} from '@angular/common';

@Component({
    selector: 'app-admin-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        MatToolbar,
        RouterLink,
        MatButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        MatIcon,
        NgOptimizedImage,
    ],
    standalone: true
})
export class HeaderComponent implements OnInit, OnDestroy {

    public email: string;
    private authStateSubscription: Subscription;

    constructor(private router: Router, private fireAuth: Auth) {
    }

    ngOnDestroy(): void {
        if (this.authStateSubscription) {
            this.authStateSubscription.unsubscribe();
        }
    }

    ngOnInit() {
        this.authStateSubscription = authState(this.fireAuth).pipe(
            take(1),
        ).subscribe(user => {
            this.email = user.email;
        });
    }

    logout() {
        this.fireAuth.signOut().then(() => {
            localStorage.clear();
            this.router.navigateByUrl('/login').then();
        });
    }
}
